$(".landing-readmore-link").click(function() {
  
   $(this).toggleClass("show-all-rm");
   $(this).closest('.banner-inner').find(".banner-description").toggleClass("show-all-desc");



      $(".featured-collections-custom-landing-banner").toggleClass("landing-banner-min-h");
      $(".featured-collections-custom-landing").toggleClass("landing-banner-top-m");


  
    if ($(this).hasClass("show-all-rm")) {
       $(this).text("Show Less");
    }else{
       $(this).text("Read more");
       
    }
  
});



$("#landing-readmore-link").click(function() {
  
   $(this).toggleClass("show-all-rm");
   $(this).closest('.banner-inner').find(".banner-description").toggleClass("show-all-desc");



      $(".featured-collections-custom-landing-banner").toggleClass("landing-banner-min-h");
      $(".featured-collections-custom-landing").toggleClass("landing-banner-top-m");


  
    if ($(this).hasClass("show-all-rm")) {
       $(this).text("Show Less");
    }else{
       $(this).text("Read more");
       
    }
  
});